import React, { useState, useRef, useEffect } from 'react';
import { FaEllipsisV, FaCodeBranch, FaTrash } from 'react-icons/fa';
import './ActionMenu.scss';

interface ActionMenuProps {
  quantity: number;
  onSplit?: () => void;
  onDelete: () => void;
  allowEdit: boolean;
}

const ActionMenu: React.FC<ActionMenuProps> = ({
  quantity,
  onSplit,
  onDelete,
  allowEdit
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      // Add dropdown-active class to parent row
      const row = menuRef.current?.closest('.selection-row');
      if (row) {
        row.classList.add('dropdown-active');
      }
    } else {
      // Remove dropdown-active class from parent row
      const row = menuRef.current?.closest('.selection-row');
      if (row) {
        row.classList.remove('dropdown-active');
      }
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleSplit = () => {
    setIsOpen(false);
    onSplit?.();
  };

  const handleDelete = () => {
    setIsOpen(false);
    onDelete();
  };

  return (
    <div className="action-menu" ref={menuRef}>
      <button
        className="action-menu-trigger"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Abrir menú de acciones"
      >
        <FaEllipsisV />
      </button>

      {isOpen && (
        <div className="action-menu-dropdown">
          {quantity > 1 && onSplit && (
            <button
              className="action-menu-item split-item"
              onClick={handleSplit}
            >
              <FaCodeBranch />
              <span>Subdividir</span>
            </button>
          )}
          {allowEdit && (
            <button
              className="action-menu-item delete-item"
              onClick={handleDelete}
            >
              <FaTrash />
              <span>Eliminar</span>
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default ActionMenu;
